import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { country_list } from '../../constants/countryList';

export default function AddressForm({
  handleNext,
  employeeDetails,
  handleChange
}) {
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Personal Information
      </Typography>
      {/* {console.log(employeeDetails)} */}
      <Box component="form" onSubmit={handleNext} sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="firstName"
              name="fname"
              label="First name"
              fullWidth
              autoComplete="given-name"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.fname}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="lastName"
              name="lname"
              label="Last name"
              fullWidth
              autoComplete="family-name"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.lname}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="address1"
              name="address"
              label="Address"
              fullWidth
              autoComplete="shipping address-line1"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.address}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="city"
              name="city"
              label="City"
              fullWidth
              autoComplete="shipping address-level2"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.city}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="state"
              name="state"
              label="State/Province/Region"
              fullWidth
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.state}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="zip"
              name="zip"
              label="Zip / Postal code"
              fullWidth
              autoComplete="shipping postal-code"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.zip}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="standard" sx={{ m: 0, minWidth: 150 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Country*
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                name="country"
                value={employeeDetails.country}
                onChange={handleChange}
                label="Country"
              >
                {country_list.map((country, index) => {
                  return (
                    <MenuItem key={index} value={country}>
                      {country}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="phone"
              name="phone"
              label="Phone Number"
              fullWidth
              autoComplete="phone"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.phone}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              id="email"
              name="email"
              label="Email"
              autoComplete="email"
              variant="standard"
              type="email"
              onChange={handleChange}
              value={employeeDetails.email}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              fullWidth
              id="about"
              name="about"
              label="About"
              autoComplete="about"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.about}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              fullWidth
              id="tags"
              name="tags"
              label="Tags"
              autoComplete="tags"
              onChange={handleChange}
              variant="standard"
              helperText="Add comma separated Tags for the User"
              value={employeeDetails.tags}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="standard" sx={{ m: 0, minWidth: 150 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Gender*
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={employeeDetails.gender}
                onChange={handleChange}
                label="Gender"
                name="gender"
              >
                <MenuItem value={'Male'}>Male</MenuItem>
                <MenuItem value={'Female'}>Female</MenuItem>
                <MenuItem value={'Other'}>Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="standard" sx={{ m: 0, minWidth: 150 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Marital Status*
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                name="maritalStatus"
                value={employeeDetails.maritalStatus}
                onChange={handleChange}
                label="Marital Status"
              >
                <MenuItem value={'Married'}>Married</MenuItem>
                <MenuItem value={'Unmarried'}>Unmarried</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="date"
              label="Date of Joining"
              type="date"
              required
              name="dateOfJoining"
              value={employeeDetails.dateOfJoining}
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="date"
              label="Date of Birth"
              value={employeeDetails.dateOfBirth}
              type="date"
              name="dateOfBirth"
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="date"
              label="Date of Leaving"
              value={employeeDetails.dateOfExit}
              type="date"
              name="dateOfExit"
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="reportingManager"
              name="reportingManager"
              label="Reporting Manager ID"
              fullWidth
              autoComplete="given-name"
              variant="standard"
              onChange={handleChange}
              helperText="Enter the ID of the Reporting Manager (if any)"
              value={employeeDetails.reportingManager}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="reportingManagerName"
              name="reportingManagerName"
              label="Reporting Manager Name"
              fullWidth
              autoComplete="given-name"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.reportingManagerName}
              helperText="Enter the Name of the Reporting Manager (if any)"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="reportingManagerEmail"
              name="reportingManagerEmail"
              label="Reporting Manager Email"
              type="email"
              fullWidth
              autoComplete="given-name"
              variant="standard"
              onChange={handleChange}
              value={employeeDetails.reportingManagerEmail}
              helperText="Enter the Email of the Reporting Manager (if any)"
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="submit"
                variant="contained"
                // onClick={handleNext}
                sx={{ mt: 3, ml: 1 }}
              >
                {'Next'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}
